import { useToasterDispatch } from 'common/ui/Toaster';
import { ToastProps } from 'common/ui/Toaster/Toast';
import { useCrossTabEventsListener, NameSpaces } from 'modules/EventsManager';
import { CrossTabNotification } from '@sironamedical/common/constants/crossTabEvents';
import { getPageType } from 'utils/pageTypes';

export const useCrossTabNotifier = () => {
  const { enqueueToast, closeToast } = useToasterDispatch();

  useCrossTabEventsListener(
    NameSpaces.CROSS_TAB_NOTIFICATION,
    ({
      source,
      payload,
    }: {
      source: 'local' | 'remote';
      payload: CrossTabNotification<ToastProps>;
    }) => {
      const currentPageType = getPageType(window.location.pathname);

      switch (payload.type) {
        case 'showCrossTabNotification':
          // Only show toasts on pages with a type listed in the targetPageTypes list
          const shouldEnqueueToast = payload.payload.targetPageTypes.some(
            (targetPageType) => targetPageType === currentPageType
          );
          if (shouldEnqueueToast) {
            const { targetPageTypes, ...toastProps } = payload.payload;
            enqueueToast(payload.payload.message, toastProps);
          }
          break;
        case 'closeCrossTabNotification':
          closeToast(payload.payload.id);
          break;
        default:
          // @ts-expect-error Runtime check
          throw new Error(`Unsupported action type "${payload.type}".`);
      }
    }
  );
};
